import firebase from "@/firebase";
import util from "@/util";
export default {
  namespaced: true,
  state: {
    tested: 0,
    goal: 0,
    lb: 0,
    percent: 0,
  },
  getters: {
    getSalt(state) {
      return state;
    },
  },
  mutations: {
    calcSalt(state, settings) {
      if (state.tested < state.goal) {
        const oz =
          ((state.goal - state.tested) *
            util.getGallons(settings.volume, settings.unitType)) /
          7468.64;
        state.lb = util.getLbs(oz, settings.unitType);
      } else if (state.tested > state.goal) {
        const p = 100 - (state.goal / state.tested) * 100 + 0.5;
        state.percent = Math.floor(p);
      } else {
        state.lb = 0;
      }
    },
    setSalt(state, salt) {
      if (!salt) {
        return;
      }
      state.tested = Number(salt.tested) || Number(state.tested);
      state.goal = Number(salt.goal) || Number(state.goal);
      state.lb = salt.lb || state.lb;
      state.percent = salt.percent || state.percent;
    },
  },
  actions: {
    async initSalt(state) {
      if (!firebase.auth.currentUser) return;
      const doc = await firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("calculator")
        .doc("salt")
        .get();
      const salt = doc.data();
      state.commit("setSalt", salt);
    },
    async saveSalt(state, data) {
      if (!firebase.auth.currentUser) return;
      await firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("calculator")
        .doc("salt")
        .set({
          tested: data.tested,
          goal: data.goal,
          lb: data.lb,
          percent: data.percent,
        });
      state.commit("setSalt", data);
    },
  },
};
